"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmissionStepFactory = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class SubmissionStepFactory {
  constructor() {
    (0, _defineProperty2.default)(this, "types", {});
  }
  addType(type, creator) {
    this.types[type] = creator;
  }
  create(executor, data, index) {
    let creator = this.types[executor];
    if (creator) {
      return creator(data, index);
    }
    throw new Error("No factory function for dumbapp step with executor: " + executor);
  }
}
exports.SubmissionStepFactory = SubmissionStepFactory;
//# sourceMappingURL=SubmissionStepFactory.js.map